const T_PREFIX = "user-info";

export const profileInfoTrns = {
  description: `${T_PREFIX}.description`,
  location: `${T_PREFIX}.location`,
  company: `${T_PREFIX}.company`,
  responsiblePerson: `${T_PREFIX}.responsible-person`,
  industry: `${T_PREFIX}.industry`,
  internationalMarket: `${T_PREFIX}.international-market`,
  representationCountries: `${T_PREFIX}.representation-countries`,
};